import * as React from 'react';
import {Input} from 'antd';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';
import locales from "../../locales";

const FIELD_PASSWORD_AGAIN = 'password_again';

class PasswordFormItem extends React.Component<BaseFormItemProps, {}> {
  public render(): React.ReactNode {
    const {disabled} = this.props;

    return (
      <>
        <BaseFormItem
          {...this.props}
          label={locales.password}
          rules={[
            ...this.props.rules ?? [],
            {
              validator: this.validateToNextPassword,
            },
          ]}
          input={<Input.Password className="mild-disabled" disabled={disabled} type={"password"}
                                 autoComplete={'no'}/>}
        />
        <BaseFormItem
          {...this.props}
          fieldId={FIELD_PASSWORD_AGAIN}
          label={locales.password_again}
          rules={[
            {
              validator: this.compareToFirstPassword,
            },
          ]}
          input={<Input.Password className="mild-disabled" disabled={disabled} type={"password"}
                                 autoComplete={'no'}/>}
        />
      </>
    );
  }

  private compareToFirstPassword = (_: any, value: any, callback: any) => {
    const {form, fieldId} = this.props;
    const password = form.getFieldValue(fieldId)
    if ((password !== undefined && password.length > 0) && !value) {
      callback(locales.password_confirm_missing);
    }
    if (value && value !== form.getFieldValue(fieldId)) {
      callback(locales.password_not_match);
    } else {
      callback();
    }
  };

  private validateToNextPassword = (_: any, value: any, callback: any) => {
    const {form} = this.props;
    if (value) {
      form.validateFields([FIELD_PASSWORD_AGAIN], {force: true});
    }
    callback();
  };
}

export default PasswordFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/PasswordFormItem.tsx